import axios from 'axios'
// import qs from 'qs'
import store from '../store';
//import JavascriptBridge from './JavascriptBridge.js'
import Vue from 'vue'
var dsBridge = require("dsbridge")

axios.defaults.timeout = 15000; //15000的超时验证

axios.interceptors.request.use(
    config => {
        if(localStorage.getItem("netWorkStatus") == "off"){
            dsBridge.call("common.showToast", { "content": "网络异常，请检查网络后重试" })
        }
        if (sessionStorage.getItem("access-token")) {
            config.headers.Authorization = sessionStorage.getItem("access-token");
        }
        if(config.data && config.data.timeout) config.timeout = config.data.timeout;
        dsBridge.call("NIODoBridge.showLoading", "")
        return config;
    },
    err => {
        // 对请求错误做些什么
        dsBridge.call("NIODoBridge.hideLoading", "")
        dsBridge.call("common.hideLoading", "")
        dsBridge.call("common.showToast", { "content": "加载超时" })
        return Promise.reject(err);
    });
// 响应拦截器
axios.interceptors.response.use(
    function(response) {
        dsBridge.call("NIODoBridge.hideLoading", "")
        dsBridge.call("common.hideLoading", "")
        return response
    },
    function(error) {
        dsBridge.call("NIODoBridge.hideLoading", "")
        dsBridge.call("common.hideLoading", "")
        console.log(error)
        if(error.code === 'ECONNABORTED' || error.message === "Network Error" || error.message.includes("timeout")){
            dsBridge.call("common.showToast", { "content": "网络不给力" })
            return Promise.resolve(error);
        }
        if (error.response.status == '600') {
            dsBridge.call(
                "NIODoBridge.openLoginPage", '',
                function(data) {

                    if (data.isSuccessed == true) {
                        function GetQueryString(name) {
                            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                            var r = window.location.search.substr(1).match(reg);
                            if (r != null) return unescape(r[2]);
                            return null;
                        }
                        axios
                            .post("/nio/nioapp/apply/getToken.jjs", {
                                type: dsBridge.call("common.getOSInfo", "").device_type,
                                taskId: GetQueryString("taskId"), //车主任务id
                                token: dsBridge.call("common.getUserInfo", "").access_token
                            })
                            .then(res => {
                                if (res.data.respCode == "0000") {
                                    sessionStorage.setItem("access-token", res.data.data.tokenId)
                                } else {

                                    dsBridge.call("common.showToast", { "content": res.data.respMsg })
                                }
                            })
                    }
                }
            );

        }
        if (error.response.status == '500') {
            dsBridge.call("common.showToast", { "content": '系统异常，请联系管理员' })
        }
        if (error.response.status == '504' || error.response.status == '502') {
            dsBridge.call("common.showToast", { "content": '网络连接失败，请重新尝试' })
        }


        //Toast({message: "服务器异常"", duration: 3000});
        return Promise.reject(error)
    }
);

export default axios


// WEBPACK FOOTER //
// ./src/api/http.js